import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { EngagementMeeting } from '../models/get-engagement-conference';
import { PostEngagementConferenceContract } from '../models/post-engagement-conference-contract';

export const AddEngagementConference = createAsyncThunk(
    'engagementMeetings/add',
    async (
        {
            engagementId,
            contract,
        }: { engagementId: number; contract: PostEngagementConferenceContract },
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;

        // core.axios resolves a failed request with the error instead of rejecting, so one
        // status check covers both cases and the user gets a single error message.
        const response = await axios
            .post(
                `/api/Marketplace/Engagements/${engagementId}/EngagementMeetings`,
                contract
            )
            .catch((error: any) => error);

        if (response?.status !== 200) {
            createNotification(
                'An error occurred while creating engagement meeting.',
                'error'
            );
            throw new Error('Failed to create engagement meeting');
        }

        createNotification(
            'Engagement meeting created successfully.',
            'success'
        );
        return response.data as EngagementMeeting;
    }
);
